var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	12733: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [1,19,2,19], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1").then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	88390: () => (loadStrictSingletonVersion("default", "@angular/core", false, [1,19,2,19], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs").then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	90080: () => (loadStrictSingletonVersion("default", "@azure/msal-angular", false, [4,3,0,18], () => (__webpack_require__.e("node_modules_azure_msal-angular_fesm2020_azure-msal-angular_mjs-_6c4a0").then(() => (() => (__webpack_require__(/*! @azure/msal-angular */ 8653))))))),
	89556: () => (loadStrictSingletonVersion("default", "@angular/router", false, [1,19,2,19], () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_5a221").then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))))),
	8358: () => (loadStrictSingletonVersion("default", "@azure/msal-browser", false, [4,3,15,0], () => (__webpack_require__.e("node_modules_azure_msal-browser_dist_index_mjs-_29931").then(() => (() => (__webpack_require__(/*! @azure/msal-browser */ 74102))))))),
	44866: () => (loadStrictSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	32778: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [2,7,8,0], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js").then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	28458: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-header", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-header_m-1d8e370").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-header */ 4185))))))),
	73184: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-menu-v2", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-menu-v2_-a2ce290").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-menu-v2 */ 34412))))))),
	2618: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-behaviors", false, [1,8,20,2], () => (__webpack_require__.e("node_modules_bancolombia_design-system-behaviors_lib_index_js").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-behaviors */ 53747))))))),
	62038: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-footer", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-footer_m-932acd0").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-footer */ 3343))))))),
	69192: () => (loadStrictSingletonVersion("default", "@angular/common", false, [1,19,2,19], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4621").then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	81398: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-icon", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-icon_mjs-_7f180").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-icon */ 82781))))))),
	21302: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-logo", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-logo_mjs-_4ea71").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-logo */ 92731))))))),
	19600: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-stroke", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-stroke_m-6e26110").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-stroke */ 25818))))))),
	62420: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-pictogram", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-pictogra-1cd0050").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-pictogram */ 22912))))))),
	74592: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-illustration", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-illustra-e0affa0").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-illustration */ 37924))))))),
	32648: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-float-menu", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-float-me-ac1efc1").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-float-menu */ 16064))))))),
	95066: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-avatar", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-avatar_m-b0e07e1").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-avatar */ 36581))))))),
	25144: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [1,19,2,19], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9341").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	95930: () => (load("default", "@shared-tokens", false, () => (__webpack_require__.e("projects_shared_tokens_api_ts-_acb70").then(() => (() => (__webpack_require__(/*! @shared-tokens */ 22093))))))),
	60176: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [1,19,2,19], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives_signals_mjs-_22bb1").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))))),
	26246: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", false, [1,19,2,19], () => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))))),
	1928: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-tooltip", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-tooltip_-3a0f141").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-tooltip */ 44183))))))),
	61848: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-helpers", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-helpers_-b483d41").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-helpers */ 90389))))))),
	87656: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-icon-button", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-icon-but-ecdb250").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-icon-button */ 1622))))))),
	37328: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-preloader", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-preloade-d0d72d0").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-preloader */ 26468))))))),
	52440: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-link", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-link_mjs-_6bd40").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-link */ 76662))))))),
	89308: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-accordion", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-accordio-7d9f971").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-accordion */ 46160))))))),
	85600: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-badge", false, [1,14,14,0], () => (__webpack_require__.e("node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-badge_mj-34302d1").then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-badge */ 95751))))))),
	66406: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [1,19,2,19], () => (__webpack_require__.e("node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0").then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"mf-host_Front_src_bootstrap_ts": [
		12733,
		88390,
		90080,
		89556,
		8358,
		44866,
		32778,
		28458,
		73184,
		2618,
		62038,
		69192,
		81398,
		21302,
		19600,
		62420,
		74592,
		32648,
		95066,
		25144,
		95930
	],
	"mf-host_Front_src_app_core_services_microfrontends-flags_service_ts": [
		88390
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9340": [
		32778,
		44866,
		88390
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4620": [
		44866,
		88390
	],
	"node_modules_angular_core_fesm2022_core_mjs": [
		60176,
		26246,
		44866,
		32778
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c1": [
		32778,
		44866,
		69192,
		88390
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f0": [
		25144,
		69192,
		88390
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a220": [
		12733,
		32778,
		44866,
		69192,
		88390
	],
	"node_modules_azure_msal-angular_fesm2020_azure-msal-angular_mjs-_6c4a1": [
		88390,
		8358,
		44866,
		69192,
		32778,
		89556
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-accordio-7d9f970": [
		1928,
		2618,
		61848,
		69192,
		81398,
		87656,
		88390
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-avatar_m-b0e07e0": [
		1928,
		2618,
		61848,
		69192,
		88390
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-badge_mj-34302d0": [
		2618,
		61848,
		69192,
		81398,
		88390,
		95066
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-float-me-ac1efc0": [
		2618,
		37328,
		61848,
		69192,
		88390
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-footer_m-932acd1": [
		88390,
		2618,
		61848,
		69192,
		81398,
		52440,
		89556,
		21302,
		19600,
		89308
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-header_m-1d8e371": [
		88390,
		2618,
		61848,
		69192,
		81398,
		21302,
		85600,
		1928,
		95066,
		32648
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-helpers_-b483d40": [
		88390
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-icon-but-ecdb251": [
		66406,
		69192,
		81398,
		88390
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-icon_mjs-_7f181": [
		61848,
		88390
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-illustra-e0affa1": [
		88390
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-link_mjs-_6bd41": [
		88390
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-logo_mjs-_4ea70": [
		88390
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-menu-v2_-a2ce291": [
		88390,
		2618,
		61848,
		89556,
		69192
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-pictogra-1cd0051": [
		88390
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-preloade-d0d72d1": [
		69192,
		88390
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-stroke_m-6e26111": [
		88390
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-tooltip_-3a0f140": [
		2618,
		69192,
		88390
	],
	"projects_shared_tokens_api_ts-_acb71": [
		88390
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1": [
		25144
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a221": [
		12733,
		32778,
		44866
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-header_m-1d8e370": [
		61848,
		85600,
		1928
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-menu-v2_-a2ce290": [
		61848
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-footer_m-932acd0": [
		61848,
		52440,
		89308
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4621": [
		44866
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-icon_mjs-_7f180": [
		61848
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-float-me-ac1efc1": [
		37328,
		61848
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-avatar_m-b0e07e1": [
		1928,
		61848
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9341": [
		32778,
		44866
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-icon-but-ecdb250": [
		66406
	],
	"node_modules_bancolombia_design-system-web_fesm2022_bancolombia-design-system-web-bc-accordio-7d9f971": [
		1928,
		87656
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0": [
		32778,
		44866
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}